import { useEffect, useState } from 'react';

interface ToastItem {
  id: number;
  message: string;
}
type Listener = (t: ToastItem) => void;

let listeners: Listener[] = [];
let nextId = 1;

/**
 * Show a transient toast. Importable from anywhere — no provider/context
 * needed; just render <Toaster /> once near the app root.
 */
export function toast(message: string): void {
  const item: ToastItem = { id: nextId++, message };
  for (const l of listeners) l(item);
}

/** Renders + auto-dismisses toasts. Mount once near the app root. */
export function Toaster() {
  const [items, setItems] = useState<ToastItem[]>([]);

  useEffect(() => {
    const l: Listener = (t) => {
      setItems((cur) => [...cur, t]);
      setTimeout(() => setItems((cur) => cur.filter((x) => x.id !== t.id)), 2000);
    };
    listeners.push(l);
    return () => {
      listeners = listeners.filter((x) => x !== l);
    };
  }, []);

  return (
    <div className="fixed bottom-4 right-4 z-[100] flex flex-col gap-2">
      {items.map((t) => (
        <div
          key={t.id}
          role="status"
          className="rounded-md bg-foreground px-4 py-2 text-sm font-medium text-background shadow-lg animate-in fade-in slide-in-from-bottom-2"
        >
          {t.message}
        </div>
      ))}
    </div>
  );
}
